<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderNav>
      <TheHeaderDropdownLang :initMenu="initMenu"/>
    </CHeaderNav>
    <CHeaderNav class="ml-auto mr-3"> 
      <CHeaderBrand class="d-lg-none" to="/" style="position: absolute;left: 55%;margin-left: -77.5px;">
        <img src="/logo.png" class="c-sidebar-brand-full" name="logo" height="32px"/>
      </CHeaderBrand>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownLang from './TheHeaderDropdownLang'

export default {
  name: 'TheHeader',
  props: {
    initMenu: {
      type: Function
    }
  },
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownLang
  }
}
</script>
